<template>
  <a-modal
    :title="title"
    :visible="open"
    :maskClosable="false"
    :keyboard="false"
    @cancel="importExcelHandleCancel"
    @ok="importExcelHandleChange"
  >
    <a-spin tip="上传中..." :spinning="uploading">
      <a-card title="剧集导入" style="width: 100%">
        <a-upload-dragger
          name="file"
          accept=".mp4"
          :multiple="true"
          :show-upload-list="false"
          list-type="picture"
          :customRequest="handleChange"
          @change="changeFile"
        >
          <p class="ant-upload-drag-icon">
            <a-icon type="inbox" />
          </p><div><font style="color: red">（导入的文件名请以视频集数命名。比如第一集视频名称为：1.MP4）</font></div>
          </p>
        </a-upload-dragger>
        <div style="margin-top: 10px;margin-bottom: 10px">
          <a-card>
            <a-row type="flex">
              <a-statistic title="总计" :value="fileList.length" />
              <a-statistic
                title="正在上传"
                :value="computedUploadVideoing"
                :style="{
                  margin: '0 32px',
                }"
                :value-style="{ color: '#cf1322' }"
              />
            </a-row>
          </a-card>

        </div>
        <div style="margin-bottom: 5px" v-for="(item,index) in fileList" :key="index" >
          <div style="width: 100%;display: flex;justify-content: space-between">
            <div><a-icon type="loading" v-if="item.percent != 100" style="margin-right: 10px" />
              <a-icon type="link" v-if="item.percent == 100" style="margin-right: 10px" />
              {{ item.name }}
              <a-progress style="height: 2px" v-if="item.percent != 100" :percent="item.percent" :show-info="false" ></a-progress>

            </div>
            <a-icon type="delete" @click.stop="clickDelete(index,1)" />
            <!--            <a-icon type="delete" @click.stop="clickDelete(index,1)" v-if="item.percent == 100" />-->
          </div>
<!--          <div style="width: 100%;display: flex;justify-content: space-between">-->
<!--            <a-progress style="height: 2px" v-if="item.percent != 100" :percent="item.percent" :show-info="false" ></a-progress>-->
<!--            <a-icon type="delete" @click.stop="clickDelete(index,1)" /></div>-->
        </div>
      </a-card>
      <a-card title="中文繁体字幕" style="width: 100%;margin-top: 10px">
        <a-upload-dragger
          name="file"
          accept=".srt,.vtt"
          :multiple="true"
          :show-upload-list="false"
          action="https://8opuad.dodrama.com/admin-api/common/local/file/uploadCos"
          @change="handleChangeZh"
        >
          <p class="ant-upload-drag-icon">
            <a-icon type="inbox" />
          </p><div><font style="color: red">（请上传.srt,.vtt文件）</font></div>
          </p>
        </a-upload-dragger>
        <div style="margin-top: 10px;margin-bottom: 10px">
          <a-card>
            <a-row type="flex">
              <a-statistic title="总计" :value="fileZhList.length" />
              <a-statistic
                title="正在上传"
                :value="computedUploadZhing"
                :style="{
                  margin: '0 32px',
                }"
                :value-style="{ color: '#cf1322' }"
              />
            </a-row>
          </a-card>

        </div>
        <div style="margin-bottom: 5px" v-for="(item,index) in fileZhList" :key="index" >
          <div style="width: 100%;display: flex;justify-content: space-between">
            <div><a-icon type="loading" v-if="item.percent != 100" style="margin-right: 10px" /> <a-icon type="link" v-if="item.percent == 100" style="margin-right: 10px" />{{ item.name }}</div>
            <a-icon type="delete" @click.stop="clickDelete(index,2)" v-if="item.percent == 100" />

          </div>
          <a-progress style="height: 2px" v-if="item.percent != 100" :percent="item.percent" :show-info="false" />
        </div>
      </a-card>

      <a-card title="英文字幕" style="width: 100%;margin-top: 10px">
        <a-upload-dragger
          name="file"
          accept=".srt,.vtt,.mov"
          :multiple="true"
          :show-upload-list="false"
          action="https://8opuad.dodrama.com/admin-api/common/local/file/uploadCos"
          @change="handleChangeEn"
        >
          <p class="ant-upload-drag-icon">
            <a-icon type="inbox" />
          </p><div><font style="color: red">（请上传.srt,.vtt文件）</font></div>
          </p>
        </a-upload-dragger>
        <div style="margin-top: 10px;margin-bottom: 10px">
          <a-card>
            <a-row type="flex">
              <a-statistic title="总计" :value="fileEnList.length" />
              <a-statistic
                title="正在上传"
                :value="computedUploadEning"
                :style="{
                  margin: '0 32px',
                }"
                :value-style="{ color: '#cf1322' }"
              />
            </a-row>
          </a-card>

        </div>
        <div style="margin-bottom: 5px" v-for="(item,index) in fileEnList" :key="index" >
          <div style="width: 100%;display: flex;justify-content: space-between">
            <div><a-icon type="loading" v-if="item.percent != 100" style="margin-right: 10px" /> <a-icon type="link" v-if="item.percent == 100" style="margin-right: 10px" />{{ item.name }}</div>
            <a-icon type="delete" @click.stop="clickDelete(index,3)" v-if="item.percent == 100" />

          </div>
          <a-progress style="height: 2px" v-if="item.percent != 100" :percent="item.percent" :show-info="false" />

        </div>
      </a-card>

      <a-card title="中文简体字幕" style="width: 100%;margin-top: 10px">
        <a-upload-dragger
          name="file"
          accept=".srt,.vtt,.mov"
          :multiple="true"
          :show-upload-list="false"
          action="https://8opuad.dodrama.com/admin-api/common/local/file/uploadCos"
          @change="handleChangeCn"
        >
          <p class="ant-upload-drag-icon">
            <a-icon type="inbox" />
          </p><div><font style="color: red">（请上传.srt,.vtt文件）</font></div>
          </p>
        </a-upload-dragger>
        <div style="margin-top: 10px;margin-bottom: 10px">
          <a-card>
            <a-row type="flex">
              <a-statistic title="总计" :value="fileCnList.length" />
              <a-statistic
                title="正在上传"
                :value="computedUploadCning"
                :style="{
                  margin: '0 32px',
                }"
                :value-style="{ color: '#cf1322' }"
              />
            </a-row>
          </a-card>

        </div>
        <div style="margin-bottom: 5px" v-for="(item,index) in fileCnList" :key="index" >
          <div style="width: 100%;display: flex;justify-content: space-between">
            <div><a-icon type="loading" v-if="item.percent != 100" style="margin-right: 10px" /> <a-icon type="link" v-if="item.percent == 100" style="margin-right: 10px" />{{ item.name }}</div>
            <a-icon type="delete" @click.stop="clickDelete(index,4)" v-if="item.percent == 100" />

          </div>
          <a-progress style="height: 2px" v-if="item.percent != 100" :percent="item.percent" :show-info="false" />

        </div>
      </a-card>

      <a-card title="马来字幕" style="width: 100%;margin-top: 10px">
        <a-upload-dragger
          name="file"
          accept=".srt,.vtt,.mov"
          :multiple="true"
          :show-upload-list="false"
          action="https://8opuad.dodrama.com/admin-api/common/local/file/uploadCos"
          @change="handleChangeBm"
        >
          <p class="ant-upload-drag-icon">
            <a-icon type="inbox" />
          </p><div><font style="color: red">（请上传.srt,.vtt文件）</font></div>
          </p>
        </a-upload-dragger>
        <div style="margin-top: 10px;margin-bottom: 10px">
          <a-card>
            <a-row type="flex">
              <a-statistic title="总计" :value="fileBmList.length" />
              <a-statistic
                title="正在上传"
                :value="computedUploadBming"
                :style="{
                  margin: '0 32px',
                }"
                :value-style="{ color: '#cf1322' }"
              />
            </a-row>
          </a-card>

        </div>
        <div style="margin-bottom: 5px" v-for="(item,index) in fileBmList" :key="index" >
          <div style="width: 100%;display: flex;justify-content: space-between">
            <div><a-icon type="loading" v-if="item.percent != 100" style="margin-right: 10px" /> <a-icon type="link" v-if="item.percent == 100" style="margin-right: 10px" />{{ item.name }}</div>
            <a-icon type="delete" @click.stop="clickDelete(index,5)" v-if="item.percent == 100" />

          </div>
          <a-progress style="height: 2px" v-if="item.percent != 100" :percent="item.percent" :show-info="false" />

        </div>
      </a-card>

      <a-card title="印尼字幕" style="width: 100%;margin-top: 10px">
        <a-upload-dragger
          name="file"
          accept=".srt,.vtt,.mov"
          :multiple="true"
          :show-upload-list="false"
          action="https://8opuad.dodrama.com/admin-api/common/local/file/uploadCos"
          @change="handleChangeIn"
        >
          <p class="ant-upload-drag-icon">
            <a-icon type="inbox" />
          </p><div><font style="color: red">（请上传.srt,.vtt文件）</font></div>
          </p>
        </a-upload-dragger>
        <div style="margin-top: 10px;margin-bottom: 10px">
          <a-card>
            <a-row type="flex">
              <a-statistic title="总计" :value="fileInList.length" />
              <a-statistic
                title="正在上传"
                :value="computedUploadIning"
                :style="{
                  margin: '0 32px',
                }"
                :value-style="{ color: '#cf1322' }"
              />
            </a-row>
          </a-card>

        </div>
        <div style="margin-bottom: 5px" v-for="(item,index) in fileInList" :key="index" >
          <div style="width: 100%;display: flex;justify-content: space-between">
            <div><a-icon type="loading" v-if="item.percent != 100" style="margin-right: 10px" /> <a-icon type="link" v-if="item.percent == 100" style="margin-right: 10px" />{{ item.name }}</div>
            <a-icon type="delete" @click.stop="clickDelete(index,6)" v-if="item.percent == 100" />

          </div>
          <a-progress style="height: 2px" v-if="item.percent != 100" :percent="item.percent" :show-info="false" />

        </div>
      </a-card>

      <a-modal :visible="previewVisible" :footer="null" @cancel="handleCancel">
        <img alt="example" style="width: 100%" :src="previewImage" />
      </a-modal>
    </a-spin>
  </a-modal>
</template>

<script>

import { importData } from '@/api/video/gather'
import UploadFileToVOD from '@/api/vod'
import UploadFileToVODFile from '@/api/UploadFileToVOD'
import axios from 'axios'
import UploadFileToOSS from '@/utils/upload-file-to-oss'
export default {
  name: 'ImportExcel',
  props: {
  },
  components: {
  },
  data () {
    return {
      title: '导入',
      open: false,
      uploadStatus: '',
      previewImage: '',
      fileList: [],
      fileZhList: [],
      fileEnList: [],
      fileCnList: [],
      fileBmList: [],
      fileInList: [],
      // 是否禁用上传
      uploading: false,
      previewVisible: false,
      updateSupport: 0,
      id: ''
    }
  },

  filters: {
  },
  created () {
  },
  computed: {
    computedUploadVideoing() {
      if (this.fileList.length > 0) {
        return this.fileList.filter(i => {
          return i.percent != 100 || i.url === ''
        }).length
      } else {
        return 0
      }
    },
    computedUploadZhing() {
      if (this.fileZhList.length > 0) {
        return this.fileZhList.filter(i => {
          return i.percent != 100 || i.url === ''
        }).length
      } else {
        return 0
      }
    },
    computedUploadEning() {
      if (this.fileEnList.length > 0) {
        return this.fileEnList.filter(i => {
          return i.percent != 100 || i.url === ''
        }).length
      } else {
        return 0
      }
    },
    computedUploadCning() {
      if (this.fileCnList.length > 0) {
        return this.fileCnList.filter(i => {
          return i.percent != 100 || i.url === ''
        }).length
      } else {
        return 0
      }
    },
    computedUploadBming() {
      if (this.fileBmList.length > 0) {
        return this.fileBmList.filter(i => {
          return i.percent != 100 || i.url === ''
        }).length
      } else {
        return 0
      }
    },
    computedUploadIning() {
      if (this.fileInList.length > 0) {
        return this.fileInList.filter(i => {
          return i.percent != 100 || i.url === ''
        }).length
      } else {
        return 0
      }
    }
  },
  watch: {
  },
  methods: {
    clickDelete(index, num) {
      const that = this
      this.$confirm({
        content: '是否确认删除呢?',
        centered: true,
        onOk() {
          if (num == 1) {
            that.fileList.splice(index, 1)
          }
          if (num == 2) {
            that.fileZhList.splice(index, 1)
          }
          if (num == 3) {
            that.fileEnList.splice(index, 1)
          }
          if (num == 4) {
            that.fileCnList.splice(index, 1)
          }
          if (num == 5) {
            that.fileBmList.splice(index, 1)
          }
          if (num == 6) {
            that.fileInList.splice(index, 1)
          }
        },
        onCancel() {
          // that.open = false
          // that.fileList = [];
          // that.fileEnList = [];
          // that.fileZhList = [];
        }
      })
    },

    async handlePreview(file) {
      if (!file.url && !file.preview) {
        file.preview = await getBase64(file.originFileObj)
      }
      this.previewImage = file.url || file.preview
      this.previewVisible = true
    },
    handleCancel() {
      this.previewVisible = false
    },

    changeFile(info) {
      // console.log('11111111111111111111111')
      // console.log(info)
      // this.fileList.push({
      //   uid:info.file.uid,
      //   name:info.file.name,
      //   status: 'done',
      //   url:'',
      //   percent:0
      // })
    },
    handleChange(info) {
      this.fileList.push({
        uid: info.file.uid,
        name: info.file.name,
        status: 'done',
        url: '',
        percent: 0,
        fileId: ''   // ✅ 预留 fileId
      })
      const that = this
      // that.form.videoUrl = ""
      const findIndex = that.fileList.findIndex(i => i.uid == info.file.uid)
      console.log('+_------' + findIndex)
      new UploadFileToVOD([info.file], {
        success: function (fileName) {
          console.log('上传成功回调', fileName)
          if (findIndex != -1) {
            that.$set(that.fileList[findIndex], 'percent', 100)
            that.fileList[findIndex].url = fileName[0]
            that.$set(that.fileList[findIndex], 'url', fileName[0])
          }
        },
        vProgress: function (val) {
          if (findIndex != -1) {
            that.fileList[findIndex].percent = val * 100
            that.$set(that.fileList[findIndex], 'percent', val * 100)
          }
        },
        fileId: function (val) {
          if (findIndex != -1) {
            //that.fileList[findIndex].fileId = val
            that.$set(that.fileList[findIndex], 'fileId', val)
          }
        }
      })
    },

    handleChangeZh(info) {
      this.fileZhList.push({
        uid: info.file.uid,
        name: info.file.name,
        status: 'done',
        url:info.file.response.data.mediaUrl,
        percent: 100
      })
    },

    handleChangeEn(info) {
      const that = this
      this.fileEnList.push({
        uid: info.file.uid,
        name: info.file.name,
        status: 'done',
        url:info.file.response.data.mediaUrl,
        percent: 100
      })
    },
    handleChangeCn(info) {
      this.fileCnList.push({
        uid: info.file.uid,
        name: info.file.name,
        status: 'done',
        url:info.file.response.data.mediaUrl,
        percent: 100
      })
    },
    handleChangeBm(info) {
      this.fileBmList.push({
        uid: info.file.uid,
        name: info.file.name,
        status: 'done',
        url:info.file.response.data.mediaUrl,
        percent: 100
      })
    },
    handleChangeIn(info) {
      this.fileInList.push({
        uid: info.file.uid,
        name: info.file.name,
        status: 'done',
        url:info.file.response.data.mediaUrl,
        percent: 100
      })
    },
    /** 导入excel窗体关闭 */
    importExcelHandleCancel (e) {
      const that = this
      if (this.fileList.length > 0 || this.fileEnList.length > 0 || this.fileZhList.length > 0 || this.fileCnList.length > 0 || this.fileBmList.length > 0 || this.fileInList.length > 0) {
        this.$confirm({
          content: '您上传的短剧/字幕文件尚未保存是否关闭?',
          centered: true,
          onOk() {
            that.open = false
            that.fileList = []
            that.fileEnList = []
            that.fileZhList = []
            that.fileCnList = []
            that.fileBmList = []
            that.fileInList = []
          },
          onCancel() {
            // that.open = false
            // that.fileList = [];
            // that.fileEnList = [];
            // that.fileZhList = [];
          }
        })
      } else {
        this.open = false
        this.fileList = []
        this.fileEnList = []
        this.fileZhList = []
        this.fileCnList = []
        this.fileBmList = []
        this.fileInList = []
      }

      // // 关闭后刷新列表
      // this.$emit('ok')
    },
    /** 下载模板操作 */
    importTemplate () {
      this.download('/video/video-gather/importTemplate', {
        ...this.queryParams
      }, `gather_template_${new Date().getTime()}.xlsx`)
    },
    /** 导入excel窗体开启 */
    importExcelHandleOpen (e) {
      this.id = e
      this.open = true
    },
    beforeUpload (file) {
      this.fileList = [file]
      return false
    },
    /** 导入excel */
    importExcelHandleChange () {
     if (this.fileList.length > 0) {
        if (this.computedUploadVideoing != 0) {
          this.$message.error('剧集文件还未上传完毕,请耐心等待')
          return
        }
     }

      if (this.fileZhList.length > 0) {
        if (this.computedUploadZhing != 0) {
          this.$message.error('中文繁体字幕文件还未上传完毕,请耐心等待')
          return
        }
      }

      if (this.fileEnList.length > 0) {
        if (this.computedUploadEning != 0) {
          this.$message.error('英文字幕文件还未上传完毕,请耐心等待')
          return
        }
      }

      if (this.fileCnList.length > 0) {
        if (this.computedUploadCning != 0) {
          this.$message.error('中文简体字幕文件还未上传完毕,请耐心等待')
          return
        }
      }

      if (this.fileBmList.length > 0) {
        if (this.computedUploadBming != 0) {
          this.$message.error('马来字幕文件还未上传完毕,请耐心等待')
          return
        }
      }

      if (this.fileInList.length > 0) {
        if (this.computedUploadIning != 0) {
          this.$message.error('印尼字幕文件还未上传完毕,请耐心等待')
          return
        }
      }

      this.uploading = true
      // const { fileList } = this
      // const formData = new FormData()
      // formData.append('file', fileList[0])
      // formData.append('updateSupport', this.updateSupport)

      const arrList = this.fileList.map(i => ({
        serialNumber: /-/.test(i.name) ? i.name.split('.')[0].split('-')[1] : i.name.split('.')[0],
        videoUrl: i.url,
        fileId: i.fileId,
        videoId: this.id
      }))
     const enList = this.fileEnList.map(i => ({
        serialNumber: /-/.test(i.name) ? i.name.split('.')[0].split('-')[1] : i.name.split('.')[0],
         subtitleEn: i.url,
       videoId: this.id
      }))
      const zhList = this.fileZhList.map(i => ({
        serialNumber: /-/.test(i.name) ? i.name.split('.')[0].split('-')[1] : i.name.split('.')[0],
        subtitle: i.url,
        videoId: this.id
      }))
      const cnList = this.fileCnList.map(i => ({
        serialNumber: /-/.test(i.name) ? i.name.split('.')[0].split('-')[1] : i.name.split('.')[0],
        subtitleCn: i.url,
        videoId: this.id
      }))
      const bmList = this.fileBmList.map(i => ({
        serialNumber: /-/.test(i.name) ? i.name.split('.')[0].split('-')[1] : i.name.split('.')[0],
        subtitleBm: i.url,
        videoId: this.id
      }))
      const inList = this.fileInList.map(i => ({
        serialNumber: /-/.test(i.name) ? i.name.split('.')[0].split('-')[1] : i.name.split('.')[0],
        subtitleIn: i.url,
        videoId: this.id
      }))
      const newArrData = {
        arrList: arrList,
        enList: enList,
        zhList: zhList,
        cnList: cnList,
        bmList: bmList,
        inList: inList
      }
      importData(JSON.stringify(newArrData)).then(response => {
        if (response.code == 1 || response.code == 20001) {
          this.fileList = []
          this.fileEnList = []
          this.fileZhList = []
          this.fileCnList = []
          this.fileBmList = []
          this.fileInList = []
          this.$message.success(response.message)
          this.open = false
          this.$emit('ok')
        } else {
          this.$message.error(response.message)
        }
      }).finally(() => {
        this.uploading = false
        this.$emit('ok')
      })
    },
    handleCheckedUpdateSupport () {
      this.updateSupport = this.updateSupport === 0 ? 1 : 0
    },
    handleRemove () {
      this.fileList = []
      this.uploading = false
    },
    handleRemoveZh () {
      this.fileZhList = []
      this.uploading = false
    },
    handleRemoveEn () {
      this.fileEnList = []
      this.fileList = []
      this.uploading = false
    },
    handleRemoveCn () {
      this.fileCnList = []
      this.uploading = false
    },
    handleRemoveBm () {
      this.fileBmList = []
      this.uploading = false
    },
    handleRemoveIn () {
      this.fileInList = []
      this.uploading = false
    }
  }
}
</script>
